export default {
  labels: {
    google_place: 'Posizione Google',
    menu_import: 'Importazione menu',
    live: 'Live',
    setting_up: 'Configurazione in corso',
  },
  buttons: {
    confirm: 'Conferma',
    cancel: 'Annulla',
    continue_setup: 'Continua configurazione',
  },
  delete_confirmation: 'Sei sicuro?',
};
